var map = {
	"./en/1/nav1.png": 89974,
	"./fi/1/nav1.png": 77680,
	"./in/1/nav1.png": 66322,
	"./th/1/nav1.png": 31517,
	"./tw/1/nav1.png": 28324,
	"./zh/1/nav1.png": 69791
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42192;